
export const upsertRefundRescueCode = async ({ commit, dispatch }, data) => {

  const { rescueCode, ...refundRescueCode } = data;

  if (rescueCode) {
    dispatch('rescueCodes/upsertRescueCode', rescueCode, { root: true })
  }

  commit('upsertOne', refundRescueCode)
}

export default {
  upsertRefundRescueCode
}
